import React, { useState, useEffect } from 'react';
import { supabase } from '../client/client';

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    const fetchQuestions = async () => {
      const { data, error } = await supabase
        .from('questions')
        .select('*')
        .order('created_at', { ascending: false });

      if (!error) {
        setQuestions(data || []);
      } else {
        console.error('Error fetching questions:', error);
      }
    };

    fetchQuestions();
  }, []);

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="accordion">
      {questions.length === 0 && (
        <p style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
          No hay preguntas disponibles por el momento.
        </p>
      )}
      {questions.map((item, index) => (
        <div key={item.id} className="accordion-item">
          <div className="accordion-title" onClick={() => handleClick(index)}>
            <span dangerouslySetInnerHTML={{ __html: item.question }} />
            <span className={`accordion-icon ${activeIndex === index ? 'active' : ''}`}>
              {activeIndex === index ? '▼' : '▲'}
            </span>
          </div>
          <div className={`accordion-content ${activeIndex === index ? 'active' : ''}`}>
            {activeIndex === index && (
              <div className="accordion-answer flex items-center mb-4">
                {item.image_url && (
                  <img
                    src={item.image_url}
                    alt={item.written_by || 'respuesta'}
                    className="accordion-image mr-10"
                    loading="lazy"
                    decoding="async"
                  />
                )}
                <div className="accordion-text">
                  {item.written_by && (
                    <p className="accordion-name">{item.written_by}</p>
                  )}
                  {item.answer ? (
                    <p className="accordion-p">{item.answer}</p>
                  ) : (
                    <p className="accordion-p" style={{ fontStyle: 'italic', color: '#888' }}>
                      Sin respuesta registrada todavía.
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
